import { TOOLS_OPTIONS } from '@/pages/Onboarding/options/Tools/TOOLS_OPTIONS';
import { ToolsOptionIdType } from '@/pages/Onboarding/options/Tools/types';

const DEFAULT_ID: ToolsOptionIdType = 'whip';
const DEFAULT_TITLE = TOOLS_OPTIONS[0].title;

export const getToolsChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): ToolsOptionIdType | null => {
  const id = TOOLS_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getToolsChoiceTitleById = (
  id: ToolsOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = TOOLS_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
